module.exports = __webpack_public_path__ + "img/inter-v3-latin-ext_latin-600.bc09228.svg";